<section id="about" >
    <div class="container">
    <header class="section-header">
      <h3 class="section-title">Software Testing </h3>
    </header>
    <p class="description">
        Our QA automation team has experienced automation testing engineers with expertise in Web, Mobile, and API testing.
    </p>
    <!-- <div class="row row-eq-height justify-content-center">
        <div class="row about-container"> 
            <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp"> 
              <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-android"></i></div>
                <h4 class="title"><a href="">Android App Development</a></h4>
                <p class="description">Based on your requirements we build stand-alone, client-server, web-service driven or data-driven mobile apps. Further, we determine the scope of your mobile development project and outline the solution that best fits your market and business needs</p>
              </div>
            </div>

            <div class="col-lg-6 background order-lg-2 order-1 wow fadeInUp">
              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fab fa-apple"></i></div>
                  <h4 class="title"><a href="">IOS Development</a></h4>
                  <p class="description">We also offer IOS development as per the client requirements.</p>
                </div>      
            </div>
          </div>
      </div> -->
  </div>
  </section>